import React, { Component } from 'react';

import Aux from '../Auxilary';
import Model from '../../components/UI/Modal/Modal';

const withErrorHandler = (WrappedComponent, axios) => {
    return class extends Component {

        state = {
            error: null
        }

        componentWillMount() {
            //super(props);
            this.requestInterceptor = axios.interceptors.request.use(req => {
                this.setState({
                    error: null
                });
                return req;
            });  
            
            this.responseInterceptor = axios.interceptors.response.use((res => res), error => {
                this.setState({
                    error: error
                });
            });  
        }

        // since withErrorHandler leads to creation of interceptors again & again calling leads to more interceptors
        // which can result in the problem
        // avoiding problem of memoryleaks
        // this lifecycle is executed when the componentis not required anymore
        componentWillUnmount() {

            // testing unmounting of inceptors works
            console.log('Will unmount' ,this.requestInterceptor, this.responseInterceptor);
            if(axios.request.interceptors) {
                axios.request.interceptors.eject(this.requestInterceptor);
                axios.response.interceptors.eject(this.responseInterceptor);
            }
            
        }

        errorConfirmedhandler = () => {
            this.setState({
                error: null
            });
        }

        render () {
            return (
                <Aux>
                    <Model 
                        modalClosed = {this.errorConfirmedhandler}
                        show={this.state.error}>
                            {this.state.error ? this.state.error.message : null}
                    </Model>
                    <WrappedComponent {...this.props}/>
                </Aux>
            );
        }
    }
}

export default withErrorHandler;